import React, { useState } from "react";
import { Form, Field } from "react-final-form";
import { useQuery } from "@tanstack/react-query";
import cx from "classnames";
import arrayMutators from "final-form-arrays";

import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import { useAuth } from "../../../../../context/AuthProvider";
import { getItemOptions } from "../../../../../services/Handlers/MasterItemsService";

import Button from "../../../../components/Button";
import InputField from "../../../../components/InputField";
import TitlePage from "../../../../components/TitlePage";
import WrapperContent from "../../../../components/WrapperContent";
import { FieldArray } from "react-final-form-arrays";
import AsyncSelect from "../../../../components/AsyncSelect";
import Spinner from "../../../../components/Spinner";
import SwitchField from "../../../../components/SwitchField";

export default function FormItem({
  handleSubmit = () => undefined,
  isLoadingSubmit = false,
  isEdit = false,
  isView = false,
  initialValues,
}) {
  const localize = useLocalization();
  const { userDetail } = useAuth();
  const [dataItem, setDataItem] = useState([]);

  useQuery(
    ["ItemList", userDetail?.businessId],
    () => getItemOptions(userDetail?.businessId),
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          setDataItem(res?.data || []);
        }
      },
      enabled: !!userDetail?.businessId,
    }
  );

  const requiredArray = (value) => {
    if (value && value.length > 0) {
      return undefined;
    } else {
      return "Required";
    }
  };

  const requiredField = (value, label) => {
    if (!value) {
      return `Harap masukkan ${label}`;
    }

    return undefined;
  };

  return (
    <Spinner loading={isLoadingSubmit}>
      <div className="card">
        <div className="card-body wrapper">
          <TitlePage
            text={
              (isEdit
                ? localize.getText("edit")
                : isView
                ? localize.getText("detail")
                : localize.getText("add")) +
              " " +
              localize.getText("package")
            }
            isBack
          />
          <Form
            onSubmit={handleSubmit}
            initialValues={initialValues}
            validate={(values) => {
              const errors = {};
              if (!values.name) {
                errors.name = localize.getText(
                  "generalRequiredFieldValidation",
                  {
                    fieldName: localize.getText("name"),
                  }
                );
              }
              if (!values.numberOfVisit) {
                errors.numberOfVisit = localize.getText(
                  "generalRequiredFieldValidation",
                  {
                    fieldName: localize.getText("numberOfVisit"),
                  }
                );
              }
              if (!values.price) {
                errors.price = localize.getText(
                  "generalRequiredFieldValidation",
                  {
                    fieldName: localize.getText("price"),
                  }
                );
              }

              return errors;
            }}
            mutators={{
              ...arrayMutators,
            }}
          >
            {({ handleSubmit, values }) => (
              <>
                <form className="wrapper-form" onSubmit={handleSubmit}>
                  <Field name="name">
                    {({ input, meta }) => (
                      <InputField
                        label={localize.getText("name")}
                        placeholder={localize.getText("placeholderField", {
                          fieldName: localize.getText("name"),
                        })}
                        error={meta.touched && meta.error}
                        onChange={(value) => input.onChange(value)}
                        onBlur={input.onBlur}
                        disabled={isView}
                        value={input.value}
                      />
                    )}
                  </Field>
                  <Field name="numberOfVisit">
                    {({ input, meta }) => (
                      <InputField
                        label={localize.getText("numberOfVisit")}
                        placeholder={localize.getText("placeholderField", {
                          fieldName: localize.getText("numberOfVisit"),
                        })}
                        error={meta.touched && meta.error}
                        onChange={(value) => input.onChange(value)}
                        onBlur={input.onBlur}
                        disabled={isView}
                        value={input.value}
                        type="number"
                      />
                    )}
                  </Field>
                  <Field name="price">
                    {({ input, meta }) => (
                      <InputField
                        label={localize.getText("price")}
                        placeholder={localize.getText("placeholderField", {
                          fieldName: localize.getText("price"),
                        })}
                        error={meta.touched && meta.error}
                        onChange={(value) => input.onChange(value)}
                        onBlur={input.onBlur}
                        disabled={isView}
                        value={input.value}
                      />
                    )}
                  </Field>

                  <WrapperContent title="Pilih Item">
                    <FieldArray
                      name={"packageItems"}
                      value={values?.packageItems}
                      validate={requiredArray}
                    >
                      {({ fields }) => (
                        <div className="d-flex flex-column gap-3">
                          {fields?.value?.map((field, index) => (
                            <div className="d-flex align-items-center gap-3">
                              <Field
                                name={`packageItems[${index}]`}
                                validate={(value) =>
                                  index !== 0 && requiredField(value, "Item")
                                }
                              >
                                {({ input, meta }) => (
                                  <AsyncSelect
                                    isGroup
                                    placeholder="Pilih Item"
                                    options={dataItem}
                                    labelKey="label"
                                    valueKey="value"
                                    onChange={(value) =>
                                      fields.update(index, value)
                                    }
                                    onBlur={input.onBlur}
                                    fullWidth
                                    error={meta.touched && meta.error}
                                    value={values?.packageItems[index]}
                                    disabled={isView}
                                  />
                                )}
                              </Field>
                              {!isView && (
                                <div className="d-flex gap-2 align-items-center">
                                  <Button
                                    variant="danger"
                                    className={cx(
                                      fields.length > 1
                                        ? "visible"
                                        : "invisible",
                                      "mb-2"
                                    )}
                                    onClick={() => fields.remove(index)}
                                  >
                                    <i class="fas fa-trash"></i>
                                  </Button>
                                  <Button
                                    className={cx(
                                      index === fields.length - 1 ||
                                        (fields.length === 1 && index === 0)
                                        ? "visible"
                                        : "invisible",
                                      "mb-2"
                                    )}
                                    onClick={() => fields.push("")}
                                  >
                                    <i class="fas fa-plus"></i>
                                  </Button>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </FieldArray>
                  </WrapperContent>

                  <Field name="active">
                    {({ input }) => (
                      <div className="mt-3 mb-2">
                        <label className="form-label font-w500">Status Paket</label>
                        <div className="mt-1">
                          <SwitchField
                            rightLabel={input.value !== false ? "Aktif" : "Non Aktif"}
                            value={input.value !== false}
                            onChange={
                              isView
                                ? () => undefined
                                : (val) => input.onChange(val)
                            }
                          />
                        </div>
                      </div>
                    )}
                  </Field>

                  {!isView && (
                    <Button
                      label={localize.getText("save")}
                      style={{ width: 180, marginTop: 42 }}
                      type="submit"
                      loading={isLoadingSubmit}
                    />
                  )}
                </form>
              </>
            )}
          </Form>
        </div>
      </div>
    </Spinner>
  );
}
